/* CP — panier : barre de progression cadeaux animée.
   Custom element ré-instancié à chaque re-rendu du tiroir ; on persiste son
   état en sessionStorage pour éviter les "sauts". (Adapté du panier Cosy.) */

/* Titre des paliers : toujours sur une seule ligne en mobile. */
function cpxFitHeadline(scope) {
  var els;
  if (scope) {
    var box = scope.closest('.cpx-rewards');
    els = box ? [box.querySelector('.cpx-rewards__headline')] : [];
  } else {
    els = Array.prototype.slice.call(document.querySelectorAll('.cpx-rewards__headline'));
  }
  els.forEach(function (el) {
    if (!el) return;
    if (window.innerWidth > 749) { el.style.fontSize = ''; el.style.whiteSpace = ''; return; }

    /* Le tiroir est ferme (display:none) : l'element n'a aucune dimension.
       Mesurer ici renvoyait 0, la boucle de reduction ne tournait donc jamais
       alors que la police avait deja ete fixee a 17px -> la phrase debordait
       et se faisait couper a l'ouverture. On ne touche a rien tant qu'il n'y
       a pas de mise en page ; l'observateur ci-dessous rappellera la fonction
       des que le tiroir s'ouvre. */
    if (!el.clientWidth) return;

    el.style.whiteSpace = 'nowrap';
    var size = 17, min = 12, guard = 0;
    el.style.fontSize = size + 'px';
    while (el.scrollWidth > el.clientWidth + 1 && size > min && guard < 40) {
      size -= 0.5; el.style.fontSize = size + 'px'; guard++;
    }

    /* Filet de securite : si meme a la taille minimale la phrase deborde
       (montant long, ecran tres etroit, traduction plus verbeuse), on autorise
       deux lignes. Mieux vaut un retour a la ligne qu'un texte tronque. */
    if (el.scrollWidth > el.clientWidth + 1) {
      el.style.whiteSpace = 'normal';
      el.style.fontSize = '';
    }
  });
}

/* Reajuste la phrase des que l'element obtient enfin des dimensions
   (ouverture du tiroir) ou que sa largeur change. On ne reagit qu'aux
   variations de LARGEUR : changer la police modifie la hauteur, et y reagir
   creerait une boucle. */
function cpxWatchHeadline(el) {
  if (!el || !window.ResizeObserver || el.__cpxWatched) return;
  el.__cpxWatched = true;
  var derniereLargeur = -1;
  new ResizeObserver(function () {
    var l = el.clientWidth;
    if (l === derniereLargeur) return;
    derniereLargeur = l;
    cpxFitHeadline(el.closest('.cpx-rewards'));
  }).observe(el);
}
if (!window.__cpxHeadlineBound) {
  window.__cpxHeadlineBound = true;
  var _cpxFitT;
  window.addEventListener('resize', function () {
    clearTimeout(_cpxFitT);
    _cpxFitT = setTimeout(function () { cpxFitHeadline(null); }, 150);
  });
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { cpxFitHeadline(null); });
  }
}

/* Barre de progression : la jauge avance et "pousse" le checkpoint cadeau. */
if (!customElements.get('cpx-cart-progress')) {
  class CpxCartProgress extends HTMLElement {
    connectedCallback() {
      cpxFitHeadline(this);
      var boite = this.closest('.cpx-rewards');
      if (boite) cpxWatchHeadline(boite.querySelector('.cpx-rewards__headline'));
      var fillEl = this.querySelector('.cpx-rewards__fill');
      var nodes = Array.prototype.slice.call(this.querySelectorAll('.cpx-rewards__node'));
      if (!fillEl) return;
      var target = parseFloat(this.dataset.fill || '0'); if (isNaN(target)) target = 0;
      var KEY = 'cpxCartFill';
      var prev = parseFloat(sessionStorage.getItem(KEY)); if (isNaN(prev)) prev = 0;
      var DUR = 750;
      fillEl.style.transition = 'none';
      fillEl.style.width = prev + '%';
      nodes.forEach(function (n) {
        var at = parseFloat(n.dataset.at || '0');
        if (prev >= at - 0.5) n.classList.add('is-on'); else n.classList.remove('is-on');
      });
      void fillEl.offsetWidth;
      requestAnimationFrame(function () {
        fillEl.style.transition = 'width ' + DUR + 'ms cubic-bezier(.4,0,.2,1)';
        fillEl.style.width = target + '%';
      });
      nodes.forEach(function (n) {
        var at = parseFloat(n.dataset.at || '0');
        var willOn = target >= at - 0.5, wasOn = prev >= at - 0.5;
        if (willOn && !wasOn) {
          var frac = (at - prev) / (target - prev || 1);
          var t = Math.max(0, Math.min(1, frac)) * DUR;
          setTimeout(function () { n.classList.add('is-on'); n.classList.add('cpx-pop'); }, t);
        } else if (!willOn && wasOn) {
          var fracD = (prev - at) / (prev - target || 1);
          var tD = Math.max(0, Math.min(1, fracD)) * DUR;
          setTimeout(function () { n.classList.remove('is-on'); }, tD);
        }
      });
      sessionStorage.setItem(KEY, String(target));
    }
  }
  customElements.define('cpx-cart-progress', CpxCartProgress);
}
